var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.merchantOptions.length > 0
    ? _c(
        "el-form",
        {
          staticClass: "select-merchant-top",
          attrs: { "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            { staticClass: "mb-0", attrs: { label: _vm.$t("merchant") } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("common.selectPlaceholder"),
                    "popper-class": "select-merchant-popper",
                  },
                  on: { change: (value) => _vm.changeMerchant(value) },
                  model: {
                    value: _vm.merchantSelected,
                    callback: function ($$v) {
                      _vm.merchantSelected = $$v
                    },
                    expression: "merchantSelected",
                  },
                },
                _vm._l(_vm.merchantOptions, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }